import type { HomeResponse } from '~/types/on24-klient'
import { useQuery } from '@tanstack/vue-query'
import { usePageQuery } from './shared'

const query = () => {
  const app = useNuxtApp()

  return useQuery({
    queryKey: ['home'],
    queryFn: () => app.$api<HomeResponse>('/'),
  })
}

export const useHomeQuery = usePageQuery(query)
